export enum ErrorType {
    BANK_FAILED = 'BANK_FAILED',
    PLATFORM_FAILED = 'PLATFORM_FAILED',
    CONFIG_FAILED = 'CONFIG_FAILED',
    AGGREGATION_FAILED = 'AGGREGATION_FAILED',
    UNKNOWN = 'UNKNOWN'
}

export interface ErrorMessage {
    title: string;
    description: string;
}